import { CRE_LOGIN_PATH } from "../constants/routes";
import { useGlobalStore } from "../context/UserContext/userContext";
import { getCreRedirectUri } from "./creAuthConfig";
import { getCreMsalInstance, initializeCreMsal } from "./creMsalInstance";

/** Clear app session and Entra CRE account; return to hospital login. */
export async function signOutCreUser() {
  useGlobalStore.getState().clear();

  try {
    await initializeCreMsal();
    const instance = getCreMsalInstance();
    await instance.logoutRedirect({
      postLogoutRedirectUri: getCreRedirectUri(),
    });
  } catch (err) {
    console.error("CRE sign-out failed:", err);
    window.location.href = CRE_LOGIN_PATH;
  }
}
